const testimonials = [
  {
    quote:
      'The most significant benefit of using Paperform has been the possibility to innovate quickly, creating new pages and types of content without the need to include a tech team or develop a whole set of tools and options. We have been able to create a bunch of new products and showcase new ideas thanks to Paperform. This includes a whole interview that was conducted and published from start-to-finish using Paperform.',
    name: 'Garbiñe Hoyo Martínez',
    business: 'ReasonWhy',
    avatar: '/website/images/reason-why.jpeg',
  },
  {
    quote:
      'Paperform seamlessly matches the look and feel of my existing landing pages. With every other form builder I’ve tried, you can tell that the form has just been embedded onto the website. With Paperform, however, my forms look like they’re part of the website; they just blend into the page and represent my brand perfectly.',
    name: 'Kassy Pajarillo',
    business: 'kassypajarillo.com',
    avatar: '/website/images/kassy.jpg',
  },
  {
    quote:
      'Ecommerce conversion rates tend to average around 2% on mobile devices... Our campaign managed to overcome this, as we reached a staggering 10% conversion rate on our Paperform store. This was largely due to Paperform’s extensive theming options, which allowed us to create a beautiful and professional-looking store that not only instilled trust in those who landed on it, but also helped translate Blütenträume’s physical brand into its online one.',
    name: 'Dennis Karle',
    business: 'Blütenträume',
    avatar: '/website/images/dennis-karle.1024x1024.jpg',
  },
  {
    quote: `My clients have to collect a lot of information from our forms based on the customer’s requests, questions and to allow images to be uploaded. Their previous forms had long interfaces, so they had high abandonment rates…After switching to Paperform there have been no customer hiccups or mistakes; we've maintained a 100% form completion rate.`,
    name: 'Chris Andrade',
    business: 'CJ Andrade Web Design',
    avatar: '/website/images/CJ.jpeg',
  },
  {
    quote:
      'Guided Mode allows our customers to only see one question at a time, making our forms more approachable and interactive. We AB tested our Paperform with our old form and found that our conversion rate increased by a staggering 91%.',
    name: 'Amadeusz Bathelt',
    business: 'Dealavo',
    avatar: '/website/images/dealavo.jpeg',
  },
];

export default testimonials;
